import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { mount } from 'enzyme';
import { noop } from 'lodash';
import TestDriver from '@wix/wix-vod-test-utils/dist/src/helpers/test-driver-base';
import { Dropdown } from './dropdown';
const options = [{
  value: 'subscribe',
  label: 'Subscribe $15.00'
}, {
  value: 'buy',
  label: 'Buy $4.99'
}, {
  value: 'rent',
  label: 'Rent $4.99'
}, {
  value: 'kek',
  label: 'Kek $499'
}, {
  value: 'kik',
  label: 'Kik $999'
}];
const defaultProps = {
  options,
  disabled: false,
  onChange: noop,
  onFocus: noop,
  selectedOption: options[1],
  placeholder: 'Placeholder',
  className: null,
  arrowClassName: null,
  placeholderClassName: null,
  menuClassName: null,
  tabIndex: '0'
};
const leftMouseButtonMouseDown = ['mousedown', {
  button: 0
}];
export class DropdownDriver extends TestDriver {
  constructor() {
    super(...arguments);
    _defineProperty(this, "_props", defaultProps);
    _defineProperty(this, "_eventsMap", {});
    _defineProperty(this, "given", {
      propOverrides: props => {
        this._props = {
          ...this._props,
          ...props
        };
        return this;
      },
      defaultProps: () => this.given.propOverrides(defaultProps),
      noOptions: () => this.given.propOverrides({
        options: [],
        selectedOption: null
      }),
      onFocus: onFocus => this.given.propOverrides({
        onFocus
      }),
      onChange: onChange => this.given.propOverrides({
        onChange
      }),
      mountedComponent: component => {
        this.component = component;
        return this;
      }
    });
    _defineProperty(this, "when", {
      created: () => {
        document.addEventListener = jest.fn((event, cb) => {
          this._eventsMap[event] = cb;
        });
        this.component = this.component || mount( /*#__PURE__*/React.createElement(Dropdown, this._props));
        return this;
      },
      clickedControl: async () => {
        this.get.control().simulate(...leftMouseButtonMouseDown);
        await this.nextTickUpdate();
        return this;
      },
      clickedNthOption: index => {
        this.get.menuItems().at(index).simulate(...leftMouseButtonMouseDown);
        return this;
      },
      dispatchedKeyDownOnControl: async keyCode => {
        this.get.control().simulate('keydown', {
          keyCode
        });
        await this.nextTickUpdate();
        return this;
      },
      dispatchedKeyDownOnDocument: keyCode => {
        this._eventsMap.keydown({
          keyCode
        });
        return this;
      },
      dispatchedKeyDownOnOption: (option, keyCode) => {
        option.simulate('keydown', {
          keyCode
        });
        return this;
      }
    });
    _defineProperty(this, "get", {
      props: () => this._props,
      control: () => this.findElementByDataHook('dropdown-control'),
      value: () => this.findElementByDataHook('dropdown-value'),
      menuItems: () => this.findElementByDataHook('dropdown-option'),
      selectedItem: () => this.get.menuItems().findWhere(component => component.prop('data-selected')),
      isOpen: () => Boolean(this.get.menuItems().length)
    });
  }
  cleanup() {
    this._eventsMap = {};
    document.addEventListener.restore();
  }
}
//# sourceMappingURL=dropdown.driver.js.map